export default __webpack_public_path__ + "assets/psd.cca4c1ac52e6e24770486bf5bc6d6ff9.png";